import api from './api';

export interface LabelValuePair {
  label: string;
  value: string;
}

export interface StatsCardDto {
  title: string;
  value: string;
  details: LabelValuePair[];
}

export interface HospitalOccupancyDto {
  makk: number;
  tenKhoa: string;
  soGiuongTongCong: number;
  soNguoiNamVien: number;
  soGiuongTrong: number;
  congSuatPhanTram: number;
}

export interface VisitStatsDto {
  ngay: string; // dd/MM/yyyy, note the case difference from the DTO in ReportTab
  tongLuotKham: number;
}

export interface DepartmentRevenueDto {
  tenKhoa: string;
  tongDoanhThu: string;
  phanTram: string;
  doanhThuGoc: number;
}

export interface FinancialReportDto {
  ngay: string;
  thanhTienBV: number;
  tongChiPhiBH: number;
  tienBN100: number;
  tienBNCCT: number;
  soBenhNhan: number;
}

export interface CumulativeServiceStatsDto {
  serviceType: string;
  reportDate: string;
  completedCount: number;
  cumulativeCount: number;
}

export interface ParaclinicalServiceStatsDto {
  serviceType: string;
  reportDate: string;
  completedCount: number;
}

export const reportService = {
  async getCumulativeServiceStats(fromDate: string, toDate: string): Promise<CumulativeServiceStatsDto[]> {
    const response = await api.get('/report/cumulative-service-stats', {
      params: { fromDate, toDate }
    });
    return response.data;
  },

  async getStatsCards(fromDate: string, toDate: string): Promise<StatsCardDto[]> {
    const response = await api.get('/report/stats', {
      params: { fromDate, toDate }
    });
    return response.data;
  },

  async getHospitalOccupancy(): Promise<HospitalOccupancyDto[]> {
    const response = await api.get('/report/hospital-occupancy');
    return response.data;
  },

  async getVisitStats(fromDate: string, toDate: string): Promise<VisitStatsDto[]> {
    const response = await api.get('/report/visit-stats', {
      params: { fromDate, toDate }
    });
    return response.data;
  },

  async getDepartmentRevenue(fromDate: string, toDate: string): Promise<DepartmentRevenueDto[]> {
    const response = await api.get('/report/department-revenue', {
      params: { fromDate, toDate }
    });
    return response.data;
  },
  
  async getFinancialReport(fromDate: string, toDate: string): Promise<FinancialReportDto[]> {
    const response = await api.get('/report/financial', {
      params: { fromDate, toDate }
    });
    return response.data;
  },
  
  async getParaclinicalServiceStats(fromDate: string, toDate: string): Promise<ParaclinicalServiceStatsDto[]> {
    const response = await api.get('/report/paraclinical-service-stats', {
      params: { fromDate, toDate }
    });
    return response.data;
  }
};
